module.exports = "/_next/static/images/PersonalizeCampaigns@2x-7d6013d1f4ace1bba8525b4942470eef.webp";